import { ReactNode } from 'react';
import { InlineMath, BlockMath } from 'react-katex';

import { ContentPointBodyWrap } from './content-point-body.style';
import { parseMathSegments } from './logic/parse-math-segments';

type Props = {
  content: string;
};

/**
 * Renders delimited LaTeX only: `$$…$$` (block), `$…$` (inline). All other text is literal.
 */
export const ContentPointBody = ({ content }: Props): ReactNode => {
  const segments = parseMathSegments(content);
  const nodes: ReactNode[] = [];

  segments.forEach((seg, index) => {
    const prefix = `s${index}`;
    if (seg.type === 'plain') {
      if (seg.text.length > 0) {
        nodes.push(seg.text);
      }
    } else if (seg.type === 'inline') {
      nodes.push(<InlineMath key={`${prefix}-i`} math={seg.latex} />);
    } else {
      nodes.push(<BlockMath key={`${prefix}-b`} math={seg.latex} />);
    }
  });

  if (nodes.length === 0) {
    return <ContentPointBodyWrap>{content}</ContentPointBodyWrap>;
  }
  if (nodes.length === 1) {
    return <ContentPointBodyWrap>{nodes[0]}</ContentPointBodyWrap>;
  }
  return <ContentPointBodyWrap>{nodes}</ContentPointBodyWrap>;
};
